// components/invoices/InvoicesTable.js
import React from 'react';
import InvoiceRow from './InvoiceRow';
import styles from './Invoices.module.css';

const InvoicesTable = ({ filteredInvoices, projectsData, isLoading }) => {
  return (
    <div className={styles.tableContainer}>
      {isLoading ? (
        <div className={styles.loadingState}>
          <p>Loading invoices...</p>
        </div>
      ) : filteredInvoices.length === 0 ? (
        <div className={styles.emptyState}>
          <p>No invoices found for the selected filter.</p>
        </div>
      ) : (
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Invoice Status</th>
              <th>Customer</th>
              <th>Project</th>
              <th>Invoice #</th>
              <th>Total</th>
              <th>Sent</th>
              <th>Due</th>
              <th>Payout Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.map((invoice) => (
              <InvoiceRow 
                key={invoice.id} 
                invoice={invoice} 
                projectsData={projectsData} 
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default InvoicesTable;